import React from 'react';

import { Alert, FlexColumn, Loading, Pagination, Table, TableBody, TableHead } from '../';
import _ from '../../locale';
import renderErrors from '../../utility/renderErrors';
import TableEmptyText from '../TableEmptyText';

export interface Props {
    page: number;
    perPage: number;
    onPageChange: (currentPage: number) => void;
    renderHeaders: () => {};
    renderItem: (item: {}) => {};
    renderEmpty?: () => {};
    areItemsLoaded: boolean;
    items: Array<{}> | null;
    totalItems: number;
    errors: {} | null;
    hidePagination?: boolean;
}

type State = {};

class DataTableView extends React.Component<Props, State> {
    static defaultProps = {};

    render() {
        const {
            errors,
            items,
            renderHeaders,
            renderItem,
            renderEmpty,
            totalItems,
            perPage,
            page,
            onPageChange,
            areItemsLoaded,
            hidePagination,
        } = this.props;

        const emptyText = renderEmpty ? renderEmpty() : _('lists_list_is_empty');

        return (
            <div style={{ height: '100%' }}>
                {errors && (
                    <FlexColumn>
                        <Alert color="error">{renderErrors(errors)}</Alert>
                    </FlexColumn>
                )}

                {items && items.length > 0 && (
                    <React.Fragment>
                        <Table stripes style={{ ...this.props.dataTableStyle }}>
                            <TableHead>{renderHeaders()}</TableHead>
                            <TableBody>{items.map(renderItem)}</TableBody>
                        </Table>

                        {!hidePagination && totalItems > perPage && (
                            <Pagination
                                totalItems={totalItems}
                                currentPage={page}
                                onChangePage={onPageChange}
                                rowsPerPage={perPage}
                            />
                        )}
                    </React.Fragment>
                )}

                {!areItemsLoaded && !errors && (
                    <FlexColumn>
                        <Loading />
                    </FlexColumn>
                )}

                {areItemsLoaded && items && items.length === 0 && (
                    <TableEmptyText>{emptyText}</TableEmptyText>
                )}
            </div>
        );
    }
}

export default DataTableView;
